import 'css-chunk:src/app/containers/Home/CommunitiesView/ProgramsDetailView/ProgramOnboardingPageConfig.scss';export default {
  "ProgramOnboardingPageConfig": "_ProgramOnboardingPageConfig_m6y2k_1",
  "save": "_save_m6y2k_4"
};